import { render, staticRenderFns } from "./tableAdminAll.vue?vue&type=template&id=0cb22389&scoped=true"
import script from "./tableAdminAll.vue?vue&type=script&lang=js"
export * from "./tableAdminAll.vue?vue&type=script&lang=js"
import style1 from "./tableAdminAll.vue?vue&type=style&index=1&id=0cb22389&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb22389",
  null
  
)

export default component.exports